import React, { useState } from "react";
import { Link } from "react-router-dom";
import { heroImages, categories as centralCategories } from "../../data/productData";

const ProductCategories = () => {
  const [expandedCategory, setExpandedCategory] = useState(null);

  const toggleCategory = (id) => {
    setExpandedCategory(expandedCategory === id ? null : id);
  };

  const categories = [
    {
      id: 1,
      name: "Building & Hardware",
      description:
        "This category includes building supplies like concrete products, roofing tiles, and marble slabs. It also covers timber and sheet materials such as plywood and PVC ceiling panels. Additionally, fencing and facades like doors, windows, and various fencing materials are included.",
      color: "from-blue-600 to-blue-800",
      hoverColor: "hover:from-blue-500 hover:to-blue-700",
      textColor: "text-blue-100",
      img: "assets/categoryimages/buildingmaterials.jpg",
      accentColor: "border-blue-300",
      link: "/building_hardware",
    },
    {
      id: 2,
      name: "Kitchen and Bathroom",
      description:
        "This category encompasses bathroom and plumbing items like basins, toilets, and shower curtains. It also includes bathroom suites such as freestanding baths and shower baths. Kitchen appliances like cookers, microwaves, and refrigerators are part of this category, along with kitchen units and cabinets.",
      color: "from-emerald-500 to-emerald-700",
      hoverColor: "hover:from-emerald-400 hover:to-emerald-600",
      textColor: "text-emerald-100",
      img: "assets/categoryimages/kitchenbathroom.jpg",
      accentColor: "border-emerald-300",
      link: "/kitchen_bathroom",
    },
    {
      id: 3,
      name: "Home and Bedrooms",
      description:
        "This category features home furniture like beds, sofas, and wardrobes. Home appliances such as TVs, washing machines, and HI-FI systems are included. Home furnishing items like wall art, clocks, and curtains are also part of this category, along with cooking and dining sets.",
      color: "from-purple-500 to-purple-700",
      hoverColor: "hover:from-purple-400 hover:to-purple-600",
      textColor: "text-purple-100",
      img: "assets/categoryimages/homebedroom.jpg",
      accentColor: "border-purple-300",
      link: "/home_bedrooms",
    },
    {
      id: 4,
      name: "MEP (Mechanical, Electrical, and Plumbing)",
      description:
        "This category includes lighting and electricals such as fans, air conditioners, and extension leads. It also covers indoor and outdoor lights.",
      color: "from-amber-500 to-amber-700",
      hoverColor: "hover:from-amber-400 hover:to-amber-600",
      textColor: "text-amber-100",
      img: "assets/categoryimages/mep.jpg",
      accentColor: "border-amber-300",
      link: "/mep_products",
    },
    {
      id: 5,
      name: "Tools and Equipments",
      description:
        "This category comprises hand tools like hammers, screwdrivers, and chisels. Equipments such as ladders, ropes, and workshop machinery are included. Power tools like drills, saws, and grinders, along with their accessories, are part of this category. Tiling tools and accessories, as well as measure and level tools, are also included.",
      color: "from-red-500 to-red-700",
      hoverColor: "hover:from-red-400 hover:to-red-600",
      textColor: "text-red-100",
      img: "assets/categoryimages/toolequipments.jpg",
      accentColor: "border-red-300",
      link: "/tools_equipments",
    },
    {
      id: 6,
      name: "Outdoor, Garden and Public Space",
      description:
        "This category includes garden power tools, garden furniture, and barbecues. It covers items for outdoor and garden spaces.",
      color: "from-teal-500 to-teal-700",
      hoverColor: "hover:from-teal-400 hover:to-teal-600",
      textColor: "text-teal-100",
      img: "assets/categoryimages/outdoor.jpg",
      accentColor: "border-teal-300",
      link: "/outdoor_space",
    },
    {
      id: 7,
      name: "Technical Flooring",
      description:
        "This category features flooring options like laminate flooring and epoxy flooring. Tiles and accessories such as ceramic tiles, vinyl flooring, and grout are included. It also covers accessories and tools for flooring and tiling.",
      color: "from-indigo-500 to-indigo-700",
      hoverColor: "hover:from-indigo-400 hover:to-indigo-600",
      textColor: "text-indigo-100",
      img: "assets/categoryimages/tilingflooring.jpg",
      accentColor: "border-indigo-300",
      link: "/tiling_flooring",
    },
    {
      id: 8,
      name: "Painting and Decoration",
      description:
        "This category includes paint and wood treatment items like masonry paint, metal paint, and primers. Decorating tools and supplies such as paint brushes, tapes, and knives are also part of this category.",
      color: "from-pink-500 to-pink-700",
      hoverColor: "hover:from-pink-400 hover:to-pink-600",
      textColor: "text-pink-100",
      img: "assets/categoryimages/paitingdecoration.jpeg",
      accentColor: "border-pink-300",
      link: "/paiting_decoration",
    },
    {
      id: 9,
      name: "Ceiling and Claddings",
      description: "This category covers plaster products, plasterboard sales and supplies, and ceiling tiles.",
      color: "from-gray-600 to-gray-800",
      hoverColor: "hover:from-gray-500 hover:to-gray-700",
      textColor: "text-gray-100",
      img: "assets/categoryimages/ceiling.jpg",
      accentColor: "border-gray-300",
      link: "/ceiling_cladding",
    },
    {
      id: 10,
      name: "Screws, Nails and Fittings",
      description:
        "This category includes various types of screws, fixers and fasteners, nails, and accessories like door handles and hinges.",
      color: "from-orange-500 to-orange-700",
      hoverColor: "hover:from-orange-400 hover:to-orange-600",
      textColor: "text-orange-100",
      img: "assets/categoryimages/screw.jpg",
      accentColor: "border-orange-300",
      link: "/screw_nails",
    },
    {
      id: 11,
      name: "Finishes and Decoration",
      description: "This category encompasses interior and exterior finishes and decorations.",
      color: "from-amber-500 to-amber-700",
      hoverColor: "hover:from-amber-400 hover:to-amber-600",
      textColor: "text-amber-100",
      img: "assets/categoryimages/finishdecoration.jpg",
      accentColor: "border-amber-300",
      link: "/finishes_decorations",
    },
  ];

  return (
    <div className="min-h-screen py-6 px-4 sm:py-8 sm:px-6 lg:px-8">
      {/* Hero using attached image */}
      <div className="relative h-56 md:h-96 mb-8 rounded-lg overflow-hidden">
        <div
          className="absolute inset-0 bg-center bg-cover"
          style={{ backgroundImage: `url(${heroImages[1]})` }}
        />
        <div className="absolute inset-0 bg-black/50 flex items-center">
          <div className="max-w-5xl px-6 lg:px-12 text-left text-white">
            <h1 className="text-3xl md:text-5xl font-extrabold leading-tight">Product Categories</h1>
            <p className="mt-3 max-w-2xl text-sm md:text-lg font-light">
              Elevating performance and aesthetics. Designed for both internal and external environments.
            </p>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 sm:mb-10">
          <p className="text-[#000] text-xl sm:text-2xl md:text-3xl mx-auto leading-tight">
            Explore our wide range of premium products for all your construction and home improvement needs.
          </p>
        </div>

        <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-5">
          {categories.map((category) => (
            <div
              key={category.id}
              className={`rounded-lg border-2 ${category.accentColor} bg-gradient-to-br ${category.color} ${category.hoverColor} transition-all duration-300 overflow-hidden shadow-md hover:shadow-lg hover:-translate-y-0.5`}>
              {/* Image Slot - More compact on mobile */}
              <div className="h-40 sm:h-48 bg-gray-800 relative overflow-hidden group">
                <div className="absolute inset-0 bg-black bg-opacity-10 group-hover:bg-opacity-10 transition-all duration-300"></div>
                <img
                  src={category.img}
                  alt={category.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>

              <div className="p-3 sm:p-4">
                <div
                  className="flex justify-between items-center cursor-pointer group"
                  onClick={() => toggleCategory(category.id)}>
                  <h3
                    className={`text-lg sm:text-xl font-semibold ${category.textColor} group-hover:text-white transition-colors duration-200`}>
                    {category.name}
                  </h3>
                  <svg
                    className={`w-5 h-5 sm:w-6 sm:h-6 ${
                      category.textColor
                    } group-hover:text-white transform transition-all duration-300 ${
                      expandedCategory === category.id ? "rotate-180" : ""
                    }`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>

                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    expandedCategory === category.id ? "max-h-96 mt-3" : "max-h-0"
                  }`}>
                  <p className={`text-xs sm:text-sm ${category.textColor} opacity-90 mb-2 sm:mb-3`}>
                    {category.description}
                  </p>
                  <Link to={`/our-products${category.link}`}>
                    <button
                      className={`w-full mt-2 px-3 py-1.5 sm:px-4 sm:py-2 rounded-md bg-white bg-opacity-10 ${category.textColor} hover:bg-opacity-20 transition-all duration-200 border ${category.accentColor} text-xs sm:text-sm font-medium`}>
                      View Products
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductCategories;
